// extracted by mini-css-extract-plugin
module.exports = {"tableSizeSelector":"aBTQE","buttonGroup":"_1lpwD"};